"use client";

import React from "react";

//Types
import { ExternalLayoutProps } from "@/types";

//styles
import * as S from "./styles";

const ExternalLayout: React.FC<ExternalLayoutProps> = ({
  className,
  children,
}) => {
  return <S.BoxExternal className={className}>{children}</S.BoxExternal>;
};

export default ExternalLayout;
